import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Image,
  Media,
  Price,
  Text,
  Logo,
  IconManager,
  subscriptionsLogoPack,
  Link,
  Disclosure,
  DescriptionList,
  List,
} from '@deseretbook/react-ui'

IconManager.register(subscriptionsLogoPack)

/**
 * Item Added page item info
 * @param {array} props array of objects
 * @returns {function} Component
 */
function ItemAddedInfo(props) {
  const { item, product, i18n, isTiny, ...rest } = props
  const productLink = `p/${product.slug}`

  return (
    <Media>
      <Media.Figure size="large">
        <Link href={productLink}>
          <Image src={product.displayImageUrl} alt="alt" imageWidth="100%" />
        </Link>
      </Media.Figure>
      <Media.Content>
        <Link href={productLink}>
          <Text color="primary">{item.product.name}</Text>
        </Link>
        <List type="horizontal">
          {item.variant.optionValues && (
            <List.Item>
              <Text hasEllipsis color="muted" size={isTiny && 'small'}>
                {item.variant.optionValues.map(({ presentation }) => presentation).join(' ')}
              </Text>
            </List.Item>
          )}
          {item.quantity > 1 && (
            <List.Item>
              <Text color="muted" size={isTiny && 'small'}>
                Qty {item.quantity}
              </Text>
            </List.Item>
          )}
        </List>
        <Text hasEllipsis size="large">
          <Price value={item.variant.displayPrice} />
        </Text>
        {item.personalization && (
          <Box paddingTop={1}>
            <Disclosure>
              <Disclosure.Header>Personalization</Disclosure.Header>
              <Disclosure.Content>
                <DescriptionList>
                  {item.personalization.data.lines.map(line => (
                    <React.Fragment>
                      <DescriptionList.Term>{line.title}</DescriptionList.Term>
                      <DescriptionList.Description>{line.value}</DescriptionList.Description>
                    </React.Fragment>
                  ))}
                  {!!item.personalization.data.style && (
                    <React.Fragment>
                      <DescriptionList.Term>Style</DescriptionList.Term>
                      <DescriptionList.Description>
                        {item.personalization.data.style}
                      </DescriptionList.Description>
                    </React.Fragment>
                  )}
                </DescriptionList>
              </Disclosure.Content>
            </Disclosure>
          </Box>
        )}
        {item.variant.platinumPointsEarnable > 0 && (
          <Box paddingTop={1}>
            <Box maxWidth={10}>
              <Logo name="platinumRewards" size="responsive" />
            </Box>
            <Text size="small">
              Earn{' '}
              <Text isBold size="small">
                {item.variant.platinumPointsEarnableCurrency}
              </Text>{' '}
              back in points.{' '}
              <Link linkRef="item-added-platinum" href="/rewards">
                <Text size="small" color="primary">
                  Learn more
                </Text>
              </Link>
            </Text>
          </Box>
        )}
        {!item.product.promotionable && (
          <Box paddingTop={2}>
            <Text isBold isItalic size="small" color="secondary" shade="light">
              {i18n.notPromotionable}
            </Text>
          </Box>
        )}
      </Media.Content>
    </Media>
  )
}

ItemAddedInfo.defaultProps = {
  item: {},
  product: {},
}

ItemAddedInfo.propTypes = {
  // Item added to cart
  item: PropTypes.shape({
    personalization: PropTypes.shape({
      data: PropTypes.shape({
        style: PropTypes.string,
        lines: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    }),
    product: PropTypes.shape({
      name: PropTypes.string,
      promotionable: PropTypes.bool,
    }),
    variant: PropTypes.shape({
      displayPrice: PropTypes.string,
      type: PropTypes.string,
      optionValues: PropTypes.arrayOf(
        PropTypes.shape({
          presentation: PropTypes.string,
        }),
      ),
      platinumPointsEarnableCurrency: PropTypes.string,
      platinumPointsEarnable: PropTypes.number,
    }),
    quantity: PropTypes.number,
  }),
  // the product added to the cart
  product: PropTypes.shape({
    displayImageUrl: PropTypes.string,
    slug: PropTypes.string,
  }),
  i18n: PropTypes.shape({
    notPromotionable: PropTypes.string,
  }),
  isTiny: PropTypes.bool,
}

export default ItemAddedInfo
